import { FAQSection } from '../FAQSection';
import type { FAQItem } from '../FAQSection';

interface ComparisonFAQProps {
  faqs: FAQItem[];
  competitorName: string;
}

export function ComparisonFAQ({ faqs, competitorName }: ComparisonFAQProps) {
  return (
    <FAQSection
      faqs={faqs}
      title={`Pollenate vs ${competitorName} — FAQ`}
      subtitle={`Common questions about switching from ${competitorName} to Pollenate.`}
      id={`faq-vs-${competitorName.toLowerCase().replace(/\s+/g, '-')}`}
    />
  );
}
